import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TraitementDto } from '@lexi-clients/lexi';

@Component({
  selector: 'app-traitement-export-bo-datagrid',
  templateUrl: './traitement-export-bo-datagrid.component.html',
  styleUrls: ['./traitement-export-bo-datagrid.component.scss'],
  standalone: false
})
export class TraitementExportBoDatagridComponent{
  @Input() visible : boolean = true;
  @Input() traitements: TraitementDto[] = [];
  @Input() titre: string = 'Résultat des exportations en attente';
  @Input() filterValue?: Array<any>;
  @Input() showFilterPanel: boolean = true;
  @Input() showPaging: boolean = true;
  @Input() pageSize: number = 50;
  @Input() height: string | number = '100%';
  @Input() manualRefreshEnabled: boolean = false;
   // Le mode compact cache la colonne des métadonnées 
   // Pour l'affichage dans les popups où l'espace est restreint
  @Input() compact : boolean = false;
  @Output() refreshRequested: EventEmitter<boolean> = new EventEmitter<boolean>();

  extractRaisonFromMetadata(rowData: TraitementDto): string {
    try {
      const metadata = rowData.metadata;
      let raison = "";
      if (metadata) {
        const index1 = metadata.indexOf("<Raison>") + 8;
        const index2 = metadata.indexOf("</Raison>");
        raison = metadata.substring(index1, index2);
      }
      return raison;
    } catch (error) {
      return "";
    }
  }
}
